// extracted by mini-css-extract-plugin
export default {"container":"Shipping_Labels_container__hAgot","link":"Shipping_Labels_link__ehkAE"};